import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Row, Form, Space, Tooltip, Empty } from "antd";
import _ from "lodash";
import { PlusOutlined, DeleteFilled, EditOutlined } from "@ant-design/icons";
import {
  getListIndicatorByYear,
  updateIndicatorByYear
} from "../../../../services/progressPerformance";
import { SUCCESS_CODE } from "../../../../lib/const";
import ConfirmModal from "../../../../components/modal/confirmModal";
import SuccessModal from "../../../../components/modal/successModal";
import FailModal from "../../../../components/modal/failModal";
import { routes } from "../../../../routes";

const IndicatorTab = ({ year }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [listIndicator, setListIndicator] = useState([]);
  const [confirmModal, setConfirmModal] = useState({
    id: 0,
    show: false,
    type: ""
  });
  // const [isUpdate, setIsUpdate] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);

  const convertDataList = async (dataList) => {
    const result = dataList.reduce((acc, item) => {
      const {
        yearOfBudget,
        projectId,
        projectNameEn,
        projectNameTh,
        indicatorId,
        indicatorNameEn,
        indicatorNameTh,
        departmentId
        // id,
      } = item;
      const yearIndex = acc.findIndex((x) => x.yearOfBudget === yearOfBudget);
      if (yearIndex === -1) {
        let object = {
          yearOfBudget,
          indicators: [
            {
              // id,
              indicatorId,
              indicatorNameEn,
              indicatorNameTh,
              projects: [
                {
                  projectId,
                  projectNameEn,
                  projectNameTh,
                  departmentId
                }
              ]
            }
          ]
        };

        // form.setFieldsValue(object);
        acc.push(object);
      } else {
        const indicatorIndex = acc[yearIndex].indicators.findIndex(
          (x) => x.indicatorId === indicatorId
        );
        if (indicatorIndex === -1) {
          let object = {
            // id,
            indicatorId,
            indicatorNameEn,
            indicatorNameTh,
            projects: [
              {
                projectId,
                projectNameEn,
                projectNameTh,
                departmentId
              }
            ]
          };
          // form.setFieldsValue(object);
          acc[yearIndex].indicators.push(object);
        } else {
          let object = {
            projectId,
            projectNameEn,
            projectNameTh,
            departmentId
          };
          acc[yearIndex].indicators[indicatorIndex].projects.push(object);
        }
      }
      return acc;
    }, []);

    return result;
  };

  const handleDelete = async () => {
    const mapDataSource = confirmModal.data.projects.map((v) => {
      return {
        projectId: v.projectId,
        projectAction: "NONE"
      };
    });

    const mergeData = Object.assign(confirmModal.data, {
      indicationAction: "DELETE",
      projects: mapDataSource
    });

    const request = {
      yearOfBudget: year,
      data: [mergeData]
    };

    const res = await updateIndicatorByYear(request);

    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);
      fetchListIndicatorByYear();
    } else {
      setFailModal(true);
    }
    setTimeout(() => {
      setFailModal(false);
      setSuccessModal(false);
    }, 2000);
    setConfirmModal({
      show: false,
      id: 0,
      type: ""
    });
  };

  const fetchListIndicatorByYear = useCallback(async () => {
    try {
      const res = await getListIndicatorByYear({ year: year, indicatorId: "" });

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        const convert = await convertDataList(result_data);
        setListIndicator(convert);
      }
    } catch (error) {}
  }, [listIndicator]);

  useEffect(() => {
    fetchListIndicatorByYear();
  }, []);

  return (
    <>
      <Form
        form={form}
        onFinish={() => {}}
        layout="vertical"
        autoComplete="off"
      >
        <Space
          direction="horizontal"
          style={{
            width: "100%",
            justifyContent: "end"
          }}
        >
          <Button
            onClick={() => navigate(routes.add_kpi + "/" + year)}
            type="primary"
            style={{
              margin: "0 0 16px 0",
              background: "#2E90FA",
              color: "#fff",
              fontWeight: 500
            }}
          >
            <PlusOutlined />
            เพิ่มตัวชี้วัด
          </Button>
        </Space>

        {_.get(listIndicator[0], "indicators") ? (
          _.get(listIndicator[0], "indicators").map((el, index) => (
            <Row
              gutter={[24, 18]}
              className="card"
              style={{ marginBottom: "12px" }}
            >
              <Col span={24}>
                <Space
                  direction="horizontal"
                  style={{
                    width: "100%",
                    justifyContent: "end"
                  }}
                >
                  <Tooltip
                    title="แก้ไข"
                    color={"#31343A"}
                    key={"edit"}
                    placement="bottom"
                  >
                    <Button
                      shape="circle"
                      icon={<EditOutlined style={{ color: "#F79009" }} />}
                      style={{ backgroundColor: "#FEF1DF", border: "none" }}
                      onClick={() =>
                        navigate(
                          routes.edit_kpi + "/" + year + "/" + el.indicatorId
                        )
                      }
                    ></Button>
                  </Tooltip>

                  <Tooltip
                    title="ลบ"
                    color={"#31343A"}
                    key={"delete"}
                    placement="bottom"
                  >
                    <Button
                      shape="circle"
                      style={{ backgroundColor: "#FDE7E5", border: "none" }}
                      onClick={() => {
                        setConfirmModal({
                          type: "delete",
                          show: true,
                          id: el.indicatorId,
                          data: el
                        });
                      }}
                    >
                      <DeleteFilled style={{ color: "#F04438" }} />
                    </Button>
                  </Tooltip>
                </Space>
              </Col>
              <Col span={24} style={{ padding: 0 }}>
                <Row
                  gutter={[24, 18]}
                  style={{
                    marginBottom: 12
                  }}
                >
                  <Col span={12}>
                    <Form.Item label="ชื่อตัวชี้วัด">
                      {el.indicatorNameTh ? el.indicatorNameTh : "-"}
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="จำนวนโครงการที่ใช้ตัวชี้วัด">
                      {el.projects.length ? el.projects.length : "-"}
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          ))
        ) : (
          <Empty />
        )}
      </Form>
      <ConfirmModal
        actionType={"delete"}
        title={"ยืนยันการลบข้อมูล"}
        modalText={"คุณต้องการลบข้อมูล ?"}
        open={confirmModal.type === "delete" ? confirmModal.show : false}
        onOk={() => {
          handleDelete();
        }}
        onCancel={() => {
          setConfirmModal({
            type: "",
            show: false,
            id: 0
          });
        }}
      />
      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal open={failModal} setOpen={setFailModal} />
    </>
  );
};

export default IndicatorTab;
